import { jwtDecode } from 'jwt-decode'
import type { IJwtPayload } from '@/shared/interfaces/jwt-payload.interface'

const getDecodedToken = (token: string): IJwtPayload | null => {
  try {
    return jwtDecode<IJwtPayload>(token)
  } catch {
    return null
  }
}

export default getDecodedToken
